'use client';

import { useDateFormatter } from '@terra/ui-formatters';
import { useTranslations } from 'next-intl';
import { useState } from 'react';
import { SettingsCard } from '../../SettingsCard';
import { SettingsRow } from '../../SettingsRow';
import { PentestReportDateEditDialog } from './PentestReportDateEditDialog';
import { toPentestReportDate } from './pentest-report-date.utils';

export type NextPentestReportCardProps = {
  nextPentestReportDate?: string | Date | null;
  isReadOnly?: boolean;
  isSaving?: boolean;
  onSave: (nextPentestReportDate: Date | null) => Promise<boolean>;
};

export function NextPentestReportCard({
  nextPentestReportDate,
  isReadOnly,
  isSaving,
  onSave,
}: NextPentestReportCardProps) {
  const t = useTranslations('designSystem.automation.pentestReport');
  const tCommon = useTranslations('designSystem.common');
  const dateFormatter = useDateFormatter();
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const scheduledDate = toPentestReportDate(nextPentestReportDate);

  return (
    <>
      <SettingsCard>
        <SettingsRow
          label={t('nextReport')}
          value={
            scheduledDate
              ? dateFormatter.formatDateOnly(scheduledDate)
              : t('notScheduled')
          }
          action={{
            label: tCommon('edit'),
            onClick: () => setIsDialogOpen(true),
            disabled: isSaving,
          }}
          isReadOnly={isReadOnly}
        />
      </SettingsCard>
      {isReadOnly ? null : (
        <PentestReportDateEditDialog
          open={isDialogOpen}
          nextPentestReportDate={nextPentestReportDate}
          isSaving={isSaving}
          onOpenChange={setIsDialogOpen}
          onSave={onSave}
        />
      )}
    </>
  );
}
